import useSWR from "swr";

import { Genesis } from "./types";
import * as utils from "./utils";

export const setupContracts = async () => {
  console.log("dynamically loading up providers and contracts");
  const contracts = await import("./contracts");
  console.log("contracts loaded", contracts);
  return contracts;
};

export async function requestGeneses(): Promise<Genesis[]> {
  const { multicall, mutagenMulticall } = await setupContracts();
  const geneses = await multicall.all(
    Array(40)
      .fill(null)
      .map((x, i) => mutagenMulticall.getGenesisState(i))
  );

  return geneses.map((genesis, genesisIdx) => {
    const id = utils.packGenesisId(genesisIdx);

    return {
      id,
      genesisIdx,
      artistId: 0,
      structure: genesis.structure || null,
      generations: genesis.generations,
      printCounts: genesis.printCounts,
      generationPrintCounts: genesis.printCounts,
      nextPrintPrice: genesis.nextPrintValue,
      nextBurnPrice: genesis.nextBurnValue,
      unclaimedFees: genesis.fees,
      moon: genesis.moon,
      punk: genesis.punk,
    };
  }, {});
}

export async function requestPoolState(): Promise<any> {
  const { evpool } = await setupContracts();
  const poolState = await evpool.getPoolState();

  return poolState;
}

export async function requestBlockNumber(): Promise<any> {
  const { provider } = await setupContracts();
  const blockNumber = await provider.getBlockNumber();

  return blockNumber;
}

export function useGeneses() {
  const { data, error, mutate } = useSWR("GenesisData", requestGeneses);

  return {
    geneses: data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
}
